import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import { Container } from "semantic-ui-react";
import moment from "moment";

import jwt from "./utils/jwt";
import request from "./utils/request";
import { AppContext } from "./utils/context";
import { apiUrl, loc } from './utils/constants';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import FetchNewTokens from "./components/FetchNewTokens";

class App extends Component {
    _mounted = false;
    state = {
        config: AppContext._currentValue.config
    };

    componentDidMount = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setTokens(queryParams);

        await apiUrl();
        this.getConfig();
        this._mounted = true;
    };

    componentWillUnmount = async() => {
        this._mounted = false;
    }

    setTokens = (queryParams) => { // Azure identities only
        const accessToken = queryParams.get('access_token');
        const refreshToken = queryParams.get('refresh_token');
        const expiresAt = queryParams.get('expiry');

        if (accessToken !== null) {
            const { cookies } = this.props;

            cookies.set("accessToken", accessToken, {
                path: "/",
                expires: moment.unix(expiresAt).toDate()
            });
            cookies.set("refreshToken", refreshToken, {
                path: "/"
            });
        }
    }

    getConfig = async () => {
        const config = await request.get(this, "api:/config", {});
        const settings = await request.get(this, "api:/settings/config", {});
        const language = await request.get(this, "api:/language", {});
        this.setState({
            config: config,
            settings: settings,
            language: language
        });
        return true;
    };

    render() {
        
        const { config, settings } = this.state;
        const { history, cookies } = this.props;
        const isAccessTokenValid = jwt.validateToken(cookies.get('accessToken'));
        const accessTokenExpiry = jwt.checkAccessTokenExpiry(cookies.get('accessToken'));

        if (!this._mounted) return <Container fluid />;
        if (!isAccessTokenValid && cookies.get('refreshToken')) return <FetchNewTokens cookies={cookies} />
        return (
            <AppContext.Provider value={this.state}>
                {accessTokenExpiry && <FetchNewTokens cookies={cookies} />}
                {isAccessTokenValid && <PrivateRoute cookies={cookies} config={config} settings={settings} history={history} />}
                <PublicRoute location={loc} cookies={cookies} history={history} settings={settings} userAuthenticated={isAccessTokenValid} />
            </AppContext.Provider>
        );
    }
}

export default withCookies(withRouter(App));
